import axios from "axios";
import Storage from "@/utils/storage";
import config from "@/config/index";
import { isFormData } from "@/utils/is";

const service = axios.create({
  baseURL: config.accountApiBaseUrl,
  timeout: config.timeout,
});

// 添加请求拦截器
service.interceptors.request.use(
  (config) => {
    const apiToken = Storage.get("apiToken");
    const brandId = Storage.get("brandId");
    const appId = Storage.get("appId");

    if (apiToken && !config.url.startsWith("qrcode")) {
      config.headers.Authorization = `Bearer ${apiToken}`;
    }
    // 默认带上brand_id和app_id参数
    if (!isFormData(config.data)) {
      if (brandId) {
        if (config.data) {
          if (config.data && config.data.length > 0) {
            config.data += `&brand_id=${brandId}`;
          } else {
            config.data += `brand_id=${brandId}`;
          }
        } else {
          config.data = `brand_id=${brandId}`;
        }
      }
      if (appId) {
        if (config.data) {
          if (config.data && config.data.length > 0) {
            config.data += `&app_id=${appId}`;
          } else {
            config.data += `app_id=${appId}`;
          }
        } else {
          config.data = `app_id=${appId}`;
        }
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 添加响应拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    const status = res.status;
    if (status && status !== 200) {
      return Promise.reject(res);
    } else {
      return res;
    }
  },
  (error) => {
    console.log(error, error.response);
    if (error && error.response && error.response.data) {
      return Promise.reject(error.response.data);
    } else {
      // other errors
      let errInfo = {
        message: "An unkown error occurred!",
        status: -9999,
      };
      return Promise.reject(errInfo);
    }
  }
);

export default service;
